// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ilY26","button":"styles_button__BI6lg","icon":"styles_icon__tAvoi","closeBtn":"styles_closeBtn__Bkijs"};